/* eslint-disable func-names */
/* eslint-disable no-extend-native */
import React from 'react';
import moment from 'moment';
import { symbol } from 'prop-types';
import Constant from '../constants/currencyMap';
import Locales from '../constants/locales';

export const flattenObject = obj => {
  var tempObj = {};
  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) continue;
    if (
      typeof obj[i] == 'object' &&
      obj[i] !== null &&
      !Array.isArray(obj[i])
    ) {
      var flatObject = flattenObject(obj[i]);
      for (var x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;
        tempObj[i + '.' + x] = flatObject[x];
      }
    } else {
      tempObj[i] = obj[i];
    }
  }
  return tempObj;
};

export const formatDate = (date, format = 'lll') =>
  moment
    .utc(date || undefined)
    .local()
    .format(format);

export const dateDifference = (date1, date2) => {
  const startDate = moment(date1).format('YYYY-MM-DD');
  const tempDate = moment(date2).format('YYYY-MM-DD');
  const endDate = moment(tempDate);
  return endDate.diff(startDate, 'days');
};
export const dateDifferenceInYear = (date1, date2) => {
  const startDate = moment(date1).format('YYYY-MM-DD');
  const tempDate = moment(date2).format('YYYY-MM-DD');
  const endDate = moment(tempDate);
  return endDate.diff(startDate, 'years');
};

export const toDateObject = value => new Date(moment(value).format('ll'));

export const prevDate = (date = new Date()) =>
  new Date(date).setDate(new Date(date).getDate() - 1);

export const currencyFormatterString = (value = 0, type = Locales.currency) => {
  const { code = Locales.code, currency = Locales.currency } =
    Constant.currencyMap[type] || {};
  const formatter = new Intl.NumberFormat(code, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  });
  const valueFormat = formatter.format(value);
  return valueFormat;
};

export const currencyFormatter = (value = 0, type = Locales.currency) => {
  const { code = Locales.code, currency = Locales.currency } =
    Constant.currencyMap[type] || {};
  const formatter = new Intl.NumberFormat(code, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  });
  const valueFormat = formatter.format(value);
  let currSymbol = null;
  let currVal = null;
  if (value >= 0) {
    currSymbol = valueFormat.charAt(0);
    currVal = valueFormat.substr(1).trim();
  } else {
    currSymbol = valueFormat.charAt(1);
    currVal = `-${valueFormat.substr(2).trim()}`;
  }
  return (
    <div className="currency">
      <div value={currSymbol}>{currSymbol}</div>
      <div>{currVal}</div>
    </div>
  );
};

export const formatPhoneNumber = phoneNumberString => {
  const cleaned = `${phoneNumberString}`.replace(/\D/g, '');
  if (Locales.region === 'US') {
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
  } else if (Locales.region === 'IN') {
    const match = cleaned.match(/^(\d{5})(\d{5})$/);
    if (match) {
      return `${match[1]}-${match[2]}`;
    }
  }
  return phoneNumberString;
};

String.prototype.formatString = function(obj) {
  let str = this;
  const options = Object.entries(obj);
  options.forEach(op => {
    const rx = new RegExp(`{${op[0]}}`, 'gi');
    str = str.replace(rx, op[1]);
  });
  return str;
};

String.prototype.replaceStrWithAmount = function(obj, defaultCurrency) {
  const str = this;
  const options = Object.entries(obj);
  const test = [];
  const st = str.split(`{${options[0][0]}}`);
  const amt = currencyFormatter(options[0][1], defaultCurrency);
  st.forEach((op, index) => {
    test.push(op);
    if (index !== st.length - 1) {
      test.push(amt);
    }
  });
  return test;
};

export const hexToRgbColor = hex => {
  const normal = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
  if (normal) return normal.slice(1).map(e => parseInt(e, 16));
  const shorthand = hex.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i);
  if (shorthand) return shorthand.slice(1).map(e => 0x11 * parseInt(e, 16));
  return null;
};
